import { ShareAltOutlined } from "@ant-design/icons";
import { Avatar, Card, Space, Typography } from "antd";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { IArticle } from "../../api/blog-api";
import "./design-card.scss";

const { Paragraph } = Typography;

export interface DesignCardProps extends IArticle {}

export const DesignCard: React.FC<DesignCardProps> = (props) => {
  const [loading] = useState(false);
  const history = useHistory();

  return (
    <Card
      hoverable
      title={
        <span
          dangerouslySetInnerHTML={{ __html: props.title }}
          onClick={() => history.push(`/view/${props.id}`)}
        />
      }
      style={{ marginTop: 10 }}
      extra={<CardActionBar />}
    >
      <Card.Meta
        avatar={<Avatar src={props.userPhotoUrl} />}
        className="d-inline-block"
        description={
          <>
            <span
              dangerouslySetInnerHTML={{ __html: props.content }}
              onClick={() => history.push(`/view/${props.id}`)}
            />
          </>
        }
        style={{ height: "4rem", overflow: "hidden" }}
      ></Card.Meta>
    </Card>
  );
};

export default DesignCard;

export const CardActionBar: React.FC = () => {
  return (
    <Space>
      {/* <FireTwoTone key="fire" />
      <MessageOutlined key="comment" /> */}
      <ShareAltOutlined />
    </Space>
  );
};
